import {classNames} from "shared/lib/classNames/classNames";
import {Header} from "widgets/Header";
import {MainPage} from "pages/MainPage";
import {AboutPage} from "pages/AboutPage";
import {MissionPage} from "pages/MissionPage";
import {ServicesPage} from "pages/ServicesPage";
import {BenefitsPage} from "pages/BenefitsPage";
import {ContactPage} from "pages/ContactPage";
import {Footer} from "widgets/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PolicyPage from "../pages/PolicyPage";
import TermsPage from "../pages/TermsPage";


const App = () => {
    return (
        <div className={classNames("app", {}, [])}>
            <Router>
                <Routes>
                    <Route path="/" element={
                        <>
                            <Header />
                            <MainPage />
                            <AboutPage />
                            <MissionPage />
                            <ServicesPage />
                            <BenefitsPage />
                            <ContactPage />
                            <Footer />
                        </>
                    } />
                    <Route path="/policy" element={
                        <>
                            <Header />
                            <PolicyPage />
                            <Footer />
                        </>
                    } />
                    <Route path="/terms" element={
                        <>
                            <Header />
                            <TermsPage />
                            <Footer />
                        </>
                    } />
                </Routes>
            </Router>
        </div>
    )
};

export default App;
